import { TYPE_CONFIG } from "../../../../pages/contents/constants";
import { fmtSize } from "../../../../pages/contents/helpers";
import { FileType, ManagedFile } from "../../../../pages/contents/types";

export default function StorageBar({ files }: { files: ManagedFile[] }) {
    const total = 1024 * 1024 * 1024; // 1 GB quota
    const used = files.reduce((s, f) => s + f.size, 0);
    // const pct = Math.min(100, (used / total) * 100);
    const byType = (["image", "document", "video", "archive", "spreadsheet", "other"] as FileType[]).map((t) => ({
        type: t, size: files.filter((f) => f.type === t).reduce((s, f) => s + f.size, 0),
    })).filter((x) => x.size > 0);

    return (
        <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 14, padding: "16px 20px" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text2)" }}>Storage</span>
                <span style={{ fontSize: 12, color: "var(--text3)" }}>{fmtSize(used)} of {fmtSize(total)}</span>
            </div>
            {/* Segmented bar */}
            <div style={{ display: "flex", height: 6, borderRadius: 3, overflow: "hidden", background: "rgba(255,255,255,0.06)", marginBottom: 10 }}>
                {byType.map((x) => (
                    <div key={x.type} style={{
                        width: `${(x.size / total) * 100}%`, background: TYPE_CONFIG[x.type].color,
                        opacity: 0.8, transition: "width 0.4s",
                    }} title={`${TYPE_CONFIG[x.type].label}: ${fmtSize(x.size)}`} />
                ))}
            </div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                {byType.map((x) => (
                    <div key={x.type} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <div style={{ width: 6, height: 6, borderRadius: "50%", background: TYPE_CONFIG[x.type].color }} />
                        <span style={{ fontSize: 11, color: "var(--text3)" }}>{TYPE_CONFIG[x.type].label} {fmtSize(x.size)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}